import LightFallback from '@/assets/no-yacht-fallback-light.svg';
import DarkFallback from '@/assets/no-yacht-fallback-new.svg';

import { useResolvedTheme } from './useResolvedTheme';

export const useNoYachtFallback = () =>
  useResolvedTheme() === 'dark' ? DarkFallback : LightFallback;
